import { createFileRoute } from "@tanstack/react-router";

type PrintOpsSearch = {
  q: string;
  branch: string;
  id: string;
  /** "albums" = mở màn "Album khách ghép" (GNPF#64) thay danh sách hàng in. */
  view?: "albums";
  /** Mã đơn chụp — tô sáng cuốn album của đơn đó. */
  order?: string;
};

export const Route = createFileRoute("/_app/print-ops/")({
  // Ba thứ đi vào địa chỉ trang: chữ đang tìm, cơ sở đang lọc, đơn đang mở.
  // Nhờ vậy lễ tân gửi được đường dẫn cho nhau ("mở giúp đơn này xem").
  // Hai ô tuỳ chọn view/order chỉ có mặt khi đang ở màn album — để mọi đường
  // dẫn cũ (chỉ ghi q/branch/id) vẫn đúng kiểu.
  validateSearch: (search: Record<string, unknown>): PrintOpsSearch => {
    const out: PrintOpsSearch = {
      q: typeof search.q === "string" ? search.q : "",
      branch: typeof search.branch === "string" ? search.branch : "",
      id: typeof search.id === "string" ? search.id : "",
    };
    if (search.view === "albums") out.view = "albums";
    if (typeof search.order === "string" && search.order) out.order = search.order;
    return out;
  },
});
